import script from "./relationship-types-selector.vue?vue&type=script&setup=true&lang=js"
export * from "./relationship-types-selector.vue?vue&type=script&setup=true&lang=js"

import "./relationship-types-selector.vue?vue&type=style&index=0&id=135ef928&lang=scss"

const __exports__ = script;

export default __exports__